var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{class:[
            _vm.size,
            `
                absolute
                top-0
                right-0
                left-0
                z-50
                flex
                flex-col
                items-center
                w-full
                min-h-screen
            `
        ],attrs:{"tabindex":"-1"}},[_c('button',{staticClass:"fixed top-0 left-0 w-full h-full bg-black bg-opacity-40",on:{"click":_vm.close}}),_vm._v(" "),(_vm.closable)?_c('button',{staticClass:"absolute top-2 right-2 z-20 flex items-center justify-center w-8 h-8 rounded-full text-2xl border border-solid border-primary bg-white hover:text-white hover:bg-primary custom-modal-close",attrs:{"aria-label":"Sluiten"},on:{"click":_vm.close}},[_c('ui-icon',{attrs:{"icon":"close"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"relative z-10 flex flex-col w-full px-4 lg:px-0 lg:my-8 lg:mx-auto overflow-y-auto rounded custom-modal-box"},[(_vm.$slots.header || _vm.title)?_c('div',[_vm._t("pre-header"),_vm._v(" "),(_vm.title)?_c('h2',[_vm._v("\n                    "+_vm._s(_vm.title)+"\n                ")]):_vm._e(),_vm._v(" "),_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"p-4 lg:p-8 bg-white custom-modal-box-content"},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"bg-blue-50"},[_vm._t("footer")],2):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }